import { Vue, Prop, Watch, Component } from 'vue-property-decorator';
import AddProduct from './addProduct';
import style from './style.vue';
import ProductList from '@/views/components/productManager/productList';
import ProductWhiteList from '@/views/components/productManager/productWhiteList';

@Component({
  mixins: [style],
  components: {
    AddProduct,
    ProductList,
    ProductWhiteList,
  },
})
export default class ProductManager extends Vue {
  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Prop()
    mode: number;

  // 选中tab
  curTab = '9';

  // 是否编辑 1 是 0 不是
  isEdit = 0;

  // 商品货号
  productId = 0;

  // 网点Id
  siteId = 0;

  sort = 0;

  page = 1;

  pageSize = 10;

  keyword = '';

  mounted() {
    this.siteId = +this.$route.params.siteId;
  }

  @Watch('curTab', { deep: true })
  onSwitch(val) {
    console.log(val);
    this.sort = 0;
    this.keyword = '';
    this.page = 1;
    this.pageSize = 10;
  }

  renderTabPan(h) {
    return (
      <el-container class="categoryConfig height-100">
        <el-aside width="100%">
          <el-tabs tab-position="left" class="el-tabs" v-model={this.curTab}>
            <el-tab-pane label="全部" class="el-tab-pane" name="9">
              {this.curTab == '9' && this.renderList(h)}
            </el-tab-pane>
            <el-tab-pane label="销售中" class="el-tab-pane" name="1">
              {this.curTab == '1' && this.renderList(h)}
            </el-tab-pane>
            <el-tab-pane label="已售罄" class="el-tab-pane" name="2">
              {this.curTab == '2' && this.renderList(h)}
            </el-tab-pane>
            <el-tab-pane label="已下架" class="el-tab-pane" name="0">
              {this.curTab == '0' && this.renderList(h)}
            </el-tab-pane>
            {/* <el-tab-pane label="白名单" class="el-tab-pane" name="3">
              {this.curTab == "3" && this.renderWhiteList(h)}
            </el-tab-pane> */}
          </el-tabs>
        </el-aside>
      </el-container>
    );
  }

  renderList(h) {
    return (
      <ProductList
        propSort={this.sort}
        propPage={this.page}
        propPageSize={this.pageSize}
        propKeyword={this.keyword}
        pType={+this.curTab}
        onSortChange={val => (this.sort = val)}
        onPageChange={val => (this.page = val)}
        onPageSizeChange={val => (this.pageSize = val)}
        onKeywordChange={val => (this.keyword = val)}
        siteId={+this.$route.params.siteId}
        onEdit={(val) => {
          (this.isEdit = 1), (this.productId = val);
        }}
      />
    );
  }

  renderWhiteList(h) {
    return (
      <ProductWhiteList
        propSort={this.sort}
        propPage={this.page}
        propPageSize={this.pageSize}
        propKeyword={this.keyword}
        pType={+this.curTab}
        onSortChange={val => (this.sort = val)}
        onPageChange={val => (this.page = val)}
        onPageSizeChange={val => (this.pageSize = val)}
        onKeywordChange={val => (this.keyword = val)}
        siteId={+this.$route.params.siteId}
        onEdit={(val) => {
          (this.isEdit = 1), (this.productId = val);
        }}
      />
    );
  }

  render(h) {
    return this.isEdit ? <AddProduct onBack={val => (this.isEdit = 0)} productId={this.productId} /> : this.renderTabPan(h);
  }
}
